import { render, staticRenderFns } from "./TaxesNewForm.vue?vue&type=template&id=de77494c"
import script from "./TaxesNewForm.vue?vue&type=script&lang=js"
export * from "./TaxesNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports